const data = {
  data: {
    Respuesta: true,
    blnError: false,
    codError: null,
    msgError: null
  }
}
  
export default data
  
